import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {ContestantStore} from '../../contestant/contestant.store';
import {filter, firstValueFrom} from 'rxjs';
import {SignUpService} from '../../auth/sign-up/sign-up.service';
import {AuthStore} from '../../auth/auth.store';
import {SnackbarService} from '../services/snackbar.service';
import {ContestSettingsStore} from '../stores/contest-settings.store';
import {CONTEST_PHASE_VALUES} from '../constants/contest-settings.constants';

export const contestantGuard: CanActivateFn = async (route, state) => {
  const contestantStore = inject(ContestantStore);
  const signUpService = inject(SignUpService);
  const router = inject(Router);
  const authStore = inject(AuthStore);
  const snackbar = inject(SnackbarService);
  const contestSettings = inject(ContestSettingsStore)?.contestSettings;

  const goesToVerificationRequired = state.url.startsWith('/contestant/verification-required');
  const goesToVerifyEmail = state.url.startsWith('/contestant/verify-email');

  const [contestant, user] = await Promise.all([
    firstValueFrom(contestantStore.contestant$.pipe(filter(Boolean))),
    firstValueFrom(authStore.user$.pipe(filter(Boolean)))
  ]);

  const {nameStepValid, companyStepValid} = signUpService.parseContestantAndCheckValidity(contestant);
  const isSubmissionPhase = contestSettings?.phase === CONTEST_PHASE_VALUES.PROJECT_SUBMISSION;

  if ((!nameStepValid || !companyStepValid) && isSubmissionPhase) {
    return router.createUrlTree(['/auth/sign-up']);
  }

  const verificationPassed = user.user_metadata['custom_email_verification_passed'];
  if (!verificationPassed && !goesToVerificationRequired && !goesToVerifyEmail) {
    return router.createUrlTree(['/contestant/verification-required']);
  } else if (!verificationPassed && goesToVerifyEmail && !route.queryParams['token']) {
    snackbar.openSnackBar({
      severity: 'error',
      message: 'Ungültiger oder abgelaufener Link'
    })
    return router.createUrlTree(['/contestant/verification-required']);
  } else if (verificationPassed && (goesToVerificationRequired || goesToVerifyEmail)) {
    return router.createUrlTree(['/contestant']);
  }

  return true;
};
